import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-pgfn-sync-options-modal',
    standalone: true,
    imports: [CommonModule, FormsModule],
    template: `
        <div class="modal-header">
            <h5 class="modal-title">Opções de Sincronização PGFN</h5>
            <button type="button" class="btn-close" (click)="cancel()" aria-label="Close"></button>
        </div>

        <div class="modal-body">
            <p class="mb-3">Escolha como deseja sincronizar os dados da PGFN:</p>

            <!-- Opção 1: Últimos N anos -->
            <div class="form-check mb-3">
                <input class="form-check-input" type="radio" name="syncMode" id="lastYears" 
                       [(ngModel)]="syncMode" value="lastYears">
                <label class="form-check-label" for="lastYears">
                    Sincronizar últimos
                    <input type="number" class="form-control form-control-sm d-inline-block mx-2" 
                           style="width: 80px;" 
                           [(ngModel)]="lastYears" 
                           min="1" 
                           max="10"
                           [disabled]="syncMode !== 'lastYears'"
                           (click)="syncMode = 'lastYears'">
                    ano(s)
                </label>
                <small class="d-block text-muted ms-4">Recomendado para atualização geral</small>
            </div>

            <!-- Opção 2: Ano específico -->
            <div class="form-check">
                <input class="form-check-input" type="radio" name="syncMode" id="specificYear" 
                       [(ngModel)]="syncMode" value="specificYear">
                <label class="form-check-label" for="specificYear">
                    Sincronizar ano específico:
                    <select class="form-select form-select-sm d-inline-block mx-2" 
                            style="width: 120px;"
                            [(ngModel)]="selectedYear"
                            [disabled]="syncMode !== 'specificYear'"
                            (click)="syncMode = 'specificYear'">
                        @for (year of years; track year) {
                            <option [value]="year">{{ year }}</option>
                        }
                    </select>
                </label>
                <small class="d-block text-muted ms-4">Para atualização pontual de um ano</small>
            </div>

            <div class="alert alert-warning mt-3 mb-0">
                <i class="ti ti-alert-triangle me-2"></i>
                <small>
                    <strong>Atenção:</strong> Este processo pode levar vários minutos dependendo da quantidade de dados.
                    Você será notificado quando a sincronização for concluída.
                </small>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancelar</button>
            <button type="button" class="btn btn-primary" (click)="confirm()">
                <i class="ti ti-refresh me-2"></i>
                Iniciar Sincronização
            </button>
        </div>
    `,
    styles: [`
        .form-check-input:disabled ~ input,
        .form-check-input:disabled ~ select {
            opacity: 0.5;
        }
    `]
})
export class PgfnSyncOptionsModalComponent {
    protected activeModal = inject(NgbActiveModal);

    protected syncMode: 'lastYears' | 'specificYear' = 'lastYears';
    protected lastYears = 5;
    protected selectedYear: number;
    protected years: number[] = [];

    constructor() {
        // Generate years from current year back to 2020
        const currentYear = new Date().getFullYear();
        this.selectedYear = currentYear;
        for (let year = currentYear; year >= 2020; year--) {
            this.years.push(year);
        }
    }

    protected cancel(): void {
        this.activeModal.dismiss();
    }

    protected confirm(): void {
        const result = {
            mode: this.syncMode,
            lastYears: this.syncMode === 'lastYears' ? this.lastYears : undefined,
            year: this.syncMode === 'specificYear' ? this.selectedYear : undefined
        };
        this.activeModal.close(result);
    }
}
